<template>
  <div id="page-container"></div>
</template>

<script>
import { useCommonStore } from "@/stores/CommonStore.ts";
import { mapActions } from "pinia";
import { isValidAccessionId } from "@/utils/accessionId.js";
export default {
  name: "QuestionnairePage",
  props: {
    accession_id: String,
    jwtToken: String,
    sample_id: String,
    role: String,
  },
  mounted() {
    this.setAccessionId(this.accession_id);
    this.setJwtToken(this.jwtToken);
    this.setSampleId(this.sample_id);
    this.setRole(this.role);
    // VP-18267: a link carrying accession_id=undefined must not become /hormoneZoomer/undefined. Without
    // a usable accession the view sends the patient to verification with the accession input shown.
    this.$router.push(isValidAccessionId(this.accession_id) ? `/hormoneZoomer/${this.accession_id}` : "/hormoneZoomer");
  },
  methods: {
    ...mapActions(()=>useCommonStore(), ["setAccessionId","setSampleId", "setJwtToken", "setRole"]),
  },
};
</script>
